import { Component, Inject, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mapa-dialog',
  templateUrl: './mapa-dialog.component.html',
  styleUrls: ['./mapa-dialog.component.scss']
})
export class MapaDialogComponent implements AfterViewInit {

  map: google.maps.Map;
  poligonoRota: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngAfterViewInit(): void {
    this.loadGoogleMapsScript().then(() => {
      const mapElement = document.getElementById('mapa');
      this.map = new google.maps.Map(mapElement!, {
        center: { lat: -15, lng: -50 },
        zoom: 5
      });

      this.visualizarCercaEletronica(this.data);
    });
  }

  private loadGoogleMapsScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ((window as any).google && (window as any).google.maps) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleApiGeoLocateKey}`;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = (err) => reject(err);

      document.head.appendChild(script);
    });
  }

  visualizarCercaEletronica(data: any): void {
    try {
      
      const geoJson = data.posicao;
      const terminalPos = data.terminalPosition;
  
      if (geoJson.type === 'polygon' || geoJson.type === 'Polygon') {
        const bounds = new google.maps.LatLngBounds();
  
        const path = geoJson.coordinates[0].map((coord: number[]) => {
          const latLng = new google.maps.LatLng(coord[1], coord[0]); // [lng, lat] → [lat, lng]
          bounds.extend(latLng);
          return latLng;
        });
  
        this.poligonoRota = new google.maps.Polygon({
          paths: path,
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35
        });
  
        this.poligonoRota.setMap(this.map);
        this.map.fitBounds(bounds);
      }
  
      // ✅ Adiciona o marcador de terminalPosition se existir
      if (terminalPos) {
        const lat = terminalPos.lat;
        const lng = terminalPos.lon;
  
        const terminalMarker = new google.maps.Marker({
          position: { lat: lat, lng: lng },
          map: this.map,
          title: 'Terminal' // texto ao passar o mouse
        });
      }
    } catch (error) {
      console.error('Erro ao desenhar cerca:', error);
    }
  }
  
  
}
